import { useMemo } from 'react';
export const cloneTracker = (trackerInstance, usageTrackerLocation) => {
  return trackerInstance.clone({
    standalone: false,
    preserveTrackerProperties: false,
    trackerName: 'copilot-toolkit',
    properties: {
      screen: usageTrackerLocation
    }
  });
};
export const useTracker = (trackerInstance, usageTrackerLocation) => {
  const copilotToolkitTracker = useMemo(() => {
    return cloneTracker(trackerInstance, usageTrackerLocation);
  }, [trackerInstance, usageTrackerLocation]);
  return {
    copilotToolkitTracker
  };
};